import { Link } from 'react-router-dom';
import { MdArrowBack, MdOpenInNew } from 'react-icons/md';

const FUENTES = [
  {
    id: 'sf-lineas',
    schema: 'COMERCIAL',
    tabla: 'sf_lineas',
    titulo: 'Líneas y cartera base',
    uso: 'Listado maestro por RUT: cliente, ejecutivo comercial, línea de negocio y datos de contacto. Es la base sobre la que se cruzan el resto de mediciones.',
    columnas: 'RUT_CLI, CLIENTE, EJECUTIVO, LINEA, etc.',
    enlaceApp: null,
  },
  {
    id: 'ejecutivos',
    schema: 'MGC',
    tabla: 'ejecutivos_estado',
    titulo: 'Equipo y estado ejecutivo MGC',
    uso: 'Responsable MGC, grupo/equipo meta y estado interno del ejecutivo (join por nombre con sf_lineas).',
    columnas: 'NOMBRE, GRUPO, ESTADO, etc.',
    enlaceApp: null,
  },
  {
    id: 'lcv-clave',
    schema: 'COMERCIAL',
    tabla: 'lcv_estado_clave',
    titulo: 'Estado clave / consulta',
    uso: 'Código de consulta Equifax/clave por RUT: 500 = clave OK, 200 = clave errónea; sin cruce en esta tabla = sin clave.',
    columnas: 'rut, cod_consulta (500/200), dv, mensaje, etc.',
    enlaceApp: null,
  },
  {
    id: 'sf-otorgamientos',
    schema: 'COMERCIAL',
    tabla: 'sf_otorgamientos',
    titulo: 'Otorgamientos (OTO)',
    uso: 'Montos OTO semestre (ventana de fechas) y desglose mes pasado por tipo de documento (TD FE/FP vs otros).',
    columnas: 'RUT_CLI, FEC_OPE, MON_ANT, TD',
    enlaceApp: { to: '/detalle-otorgamientos', label: 'Ver detalle de operaciones' },
    avisoEnlace:
      'Esa pantalla no ejecuta la misma consulta que el panel: consume el endpoint /seg-com/factoring-detalle-ope (Seg-Com), que normalmente entrega el corte del informe mensual (por eso puedes ver solo abril u otro mes único). El panel Marketing sí suma en MySQL los últimos 6 meses calendario en COMERCIAL.sf_otorgamientos.',
  },
  {
    id: 'cesion-facturas',
    schema: 'COMERCIAL',
    tabla: 'cesion_facturas',
    titulo: 'Cesiones (hoja Excel)',
    uso: 'Totales por deudor: desde inicio de semestre OTO hasta fin de semestre + 5 días (incluye reportes con FECHA_REPORTE al inicio del mes siguiente). Fecha efectiva: FECHA_REPORTE, o si falta FCH_CESION / FCH_EMIS_DTE. DEUDOR y CESIONARIO normalizados para el cruce. Matriz MGC.tipo_factoring (BANCO/IF); fuera → OTRO.',
    columnas: 'cesion_facturas.*; matriz MGC.tipo_factoring (CESIONARIO, RZ_CESIONARIO, BANCO)',
    enlaceApp: { to: '/factoring', label: 'Ir a Factoring' },
  },
  {
    id: 'sf-factoring',
    schema: 'COMERCIAL',
    tabla: 'sf_factoring',
    titulo: 'Factoring (mora / cobranza)',
    uso: 'Solo para FILTRO FAM COBRANZA (cobranza judicial) en el universo de operaciones de factoring.',
    columnas: 'RUT_CLIENTE, FAMILIA_COBRANZA',
    enlaceApp: { to: '/factoring', label: 'Ir a Factoring' },
  },
  {
    id: 'bloqueo',
    schema: 'PANEL',
    tabla: 'BLOQUEO_CLIENTE',
    titulo: 'Bloqueo de cliente',
    uso: 'Estado de bloqueo agregado por RUT-DV (TRIM en SQL + variantes de clave al cruzar con sf_lineas). FILTRO: BLOQUEO GERENCIA = NO si el estado indica bloqueo (BLOQUEADO, BLOQUEO, textos que contienen BLOQUEADO; excluye SIN BLOQUEO / DESBLOQUEO / NO BLOQUEADO).',
    columnas: 'RUT_CLIENTE, DV_CLIENTE, ESTADO_ACTUAL',
    enlaceApp: null,
  },
];

const PanelDetalleOtoFuentes = () => (
  <div className="p-6">
    <div className="flex flex-wrap items-center gap-3 mb-6">
      <Link
        to="/panel-marketing/placeholder-1"
        className="btn-primary inline-flex items-center gap-2"
        style={{ textDecoration: 'none' }}
      >
        <MdArrowBack className="w-5 h-5" />
        Volver al panel
      </Link>
    </div>

    <div className="mb-6">
      <h1 className="text-2xl font-bold text-gray-800">Fuentes de datos — Detalle Otorgamientos</h1>
      <p className="text-gray-600 mt-2 max-w-3xl">
        El reporte de Gestión Campaña se arma en backend (Lambda) cruzando las tablas siguientes en MySQL.
        Donde existe una pantalla equivalente en esta aplicación, puedes abrirla para revisar operaciones o módulos relacionados.
      </p>
    </div>

    <div className="space-y-4">
      {FUENTES.map((f) => (
        <section key={f.id} id={f.id} className="seccion-datos">
          <h3 className="!mb-2">{f.titulo}</h3>
          <p className="text-sm font-mono text-gray-700 mb-2">
            {f.schema}.{f.tabla}
          </p>
          <p className="text-gray-700 text-sm mb-2">{f.uso}</p>
          <p className="text-xs text-gray-500">
            <span className="font-semibold text-gray-600">Campos relevantes:</span> {f.columnas}
          </p>
          {f.enlaceApp && (
            <div className="mt-4 space-y-2">
              <Link
                to={f.enlaceApp.to}
                className="btn-primary inline-flex items-center gap-2 text-sm py-2 px-4"
                style={{ textDecoration: 'none' }}
              >
                {f.enlaceApp.label}
                <MdOpenInNew className="w-4 h-4" />
              </Link>
              {f.avisoEnlace && (
                <p className="text-xs text-amber-900 bg-amber-50 border border-amber-200 rounded-md p-3 max-w-3xl">
                  {f.avisoEnlace}
                </p>
              )}
            </div>
          )}
        </section>
      ))}
    </div>
  </div>
);

export default PanelDetalleOtoFuentes;
